import { memo } from 'react';
import GenericIcon from './GenericIcon';

export default memo(({ direction, ...params }) => (
  <GenericIcon {...params} transform={`scale(1, ${direction === 'up' ? -1 : 1})`}>
    <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" />
    <path d="M12 8L8 12" />
    <path d="M12 8V16" />
    <path d="M16 12L12 8" />
  </GenericIcon>
));
